





























import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { Device } from "../../../types/core";
import Component from "vue-class-component";
import DownlinksQueueSection from "@/components/device/DownlinksQueueSection.vue";
import { curDeviceService } from "@/services/DeviceService";
import { DeviceCommandReq } from "@/services/CoreClient";
import _ from "lodash";

@Component({
  components: {
    DownlinksQueueSection,
  },
})
export default class PowerPilotControl extends Vue {
  @Prop({ default: () => { }, type: Object }) device!: Device;
  @Prop({ default: () => { }, type: Object }) bus!: Vue;

  private httpBusy: boolean = false;

  private error: string = '';

  created() { }
  async mounted() { }

  async deviceReset() {
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'device_reset',
        updateConfiguration: true,
      } as DeviceCommandReq);
      this.bus.$emit('refresh');

      setTimeout(() => { this.bus.$emit('close'); }, 2000);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async burstMode() {
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'burst_mode',
        updateConfiguration: true,
      } as DeviceCommandReq);
      this.bus.$emit('refresh');

      setTimeout(() => { this.bus.$emit('close'); }, 2000);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  cancel() {
    this.$emit('close');
  }
}
